var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 1.35156L5.21875 4.5625C5.07812 4.6875 4.92188 4.75 4.75 4.75C4.57812 4.75 4.42969 4.6875 4.30469 4.5625L1.1875 1.35156C1 1.13281 0.953125 0.898438 1.04688 0.648438C1.15625 0.398438 1.35938 0.265625 1.65625 0.25H7.84375C8.14062 0.265625 8.34375 0.398438 8.45312 0.648438C8.54688 0.898438 8.5 1.13281 8.3125 1.35156Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSortDesc);
export default __webpack_public_path__ + "static/media/icons_sort_desc.0a7e8377.svg";
export { ForwardRef as ReactComponent };